<template>
  <div
    id="detailTop"
    :class="[playClass ? 'has_play_img' : '']"
    @touchmove.stop.prevent
  >
    <img style="height: 5.7rem;" v-show="!courseVideUrl" :src="pic" />
    <video
      v-show="courseVideUrl"
      ref="video"
      id="ele_video"
      :poster="pic"
      controls="true"
      :src="courseVideUrl"
      playsinline="true"
      webkit-playsinline="true"
      x-webkit-airplay="true"
      x5-playsinline=""
    ></video>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { contentview } from '@/Mixin/contentview.js';
export default {
  name: '',
  mixins: [contentview],
  props: {
    pic: {
      default: ''
    },
    categoriesArr: {
      type: Array,
      default() {
        return [];
      }
    },
    detailObj: {
      type: Object,
      default() {
        return {};
      }
    },
    scType: ''
  },
  data() {
    return {
      show: false,
      controls: false,
      playClass: false
    };
  },

  methods: {},
  computed: {
    ...mapState({
      courseVideUrl: state => state.courseVideUrl
    })
  },
  watch: {
    courseVideUrl(val) {},
    detailObj(val) {
      this.$nextTick(() => {
        this.pageStayTime('录播');
        this.videoPlay('录播');
      });
    }
  }
};
</script>

<style scoped lang="less">
#detailTop {
  width: 100%;
  height: 5.6266rem;
  position: relative;
  * {
    max-width: 100%;
    height: 5.6266rem;
  }
  #ele_video {
    width: 100%;
    height: 5.6266rem;
  }
}

.has_play_img:before {
  content: '';
  background: url('https://cdn.yxvzb.com/img/playimg.png') no-repeat;
  background-size: 100%;
  width: 2rem;
  height: 2rem;
  position: absolute;
  top: 1.5rem;
  left: 50%;
  z-index: 2;
  margin-left: -1rem;
}
</style>
